import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Homepage from "./pages/Homepage";
import About from "./pages/About";
import Solutions from "./pages/Solutions";
import AIConsulting from "./pages/solutions/AIConsulting";
import Contactability from "./pages/solutions/Contactability";
import BrokerAnalytics from "./pages/solutions/BrokerAnalytics";
import CampaignSolutions from "./pages/solutions/CampaignSolutions";
import UnclaimedFunds from "./pages/solutions/UnclaimedFunds";
import AILearning from "./pages/AILearning";
import Experience from "./pages/Experience";
import Insights from "./pages/Insights";
import Contact from "./pages/Contact";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <div className="dark-theme">
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Homepage />} />
              <Route path="/about" element={<About />} />
              <Route path="/solutions" element={<Solutions />} />
              <Route path="/solutions/ai-consulting" element={<AIConsulting />} />
              <Route path="/solutions/contactability" element={<Contactability />} />
              <Route path="/solutions/broker-analytics" element={<BrokerAnalytics />} />
              <Route path="/solutions/campaign-solutions" element={<CampaignSolutions />} />
              <Route path="/solutions/unclaimed-funds" element={<UnclaimedFunds />} />
              <Route path="/ai-learning" element={<AILearning />} />
              <Route path="/experience" element={<Experience />} />
              <Route path="/insights" element={<Insights />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </main>
          <Footer />
          <Toaster />
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;